import { Box, Chip } from '@mui/material'
import React from 'react'

interface ChipboxBoxProps<T> {
  collection: T[]
  keyFinder: (item: T) => string
}

export const ChipboxBox = <T extends unknown>({
  collection,
  keyFinder
}: ChipboxBoxProps<T>) => {
  return (
    <Box
      p={['2px', '10px']}
      sx={(theme) => ({
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexWrap: 'wrap',
        gap: theme.spacing(0.2)
      })}
    >
      {collection.map((item) => (
        <Chip label={keyFinder(item)} />
      ))}
    </Box>
  )
}
